import React from 'react'

import styles from './errorFallback.module.css'

const ErrorFallback = ({error, componentStack, resetErrorBoundary}) => {
    return (
        <div role="alert" className={styles['fondo-error']}>
            <div className={styles['contenedor-centro']}>
                <label className={styles['titulo-error']}>¡Vaya!</label>
                <br />  <label className={styles['titulo-error']}>Algo salió mal </label>
                <p>
                    Se ha producido un error al mostrar esta página Web.<br />
                    Para continuar, vuelve a cargar la página o accede nuevamente.
                </p>
                <button className={styles['btn-reintentar']} onClick={resetErrorBoundary}>
                    Reintentar
                </button>
            </div>
        </div>
    )
}

export default ErrorFallback